"use strict";
/*
 * HSRangeSlider
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var base_plugin_1 = __importDefault(require("../base-plugin"));
var HSRangeSlider = /** @class */ (function (_super) {
    __extends(HSRangeSlider, _super);
    function HSRangeSlider(el, options, events) {
        var _this = _super.call(this, el, options, events) || this;
        var data = el.getAttribute('data-hs-range-slider');
        var dataOptions = data ? JSON.parse(data) : {};
        _this.concatOptions = __assign(__assign(__assign({}, dataOptions), options), { cssClasses: __assign(__assign({}, noUiSlider.cssClasses), _this.processClasses(dataOptions.cssClasses)) });
        _this.init();
        return _this;
    }
    Object.defineProperty(HSRangeSlider.prototype, "formattedValue", {
        get: function () {
            var _this = this;
            var values = this.el.noUiSlider.get();
            if (Array.isArray(values) && this.format) {
                var updateValues_1 = [];
                values.forEach(function (val) {
                    updateValues_1.push(_this.format.to(val));
                });
                return updateValues_1;
            }
            else if (this.format) {
                return this.format.to(values);
            }
            else {
                return values;
            }
        },
        enumerable: false,
        configurable: true
    });
    HSRangeSlider.prototype.processClasses = function (cl) {
        var mergedClasses = {};
        Object.keys(cl).forEach(function (key) {
            if (key)
                mergedClasses[key] = "".concat(noUiSlider.cssClasses[key], " ").concat(cl[key]);
        });
        return mergedClasses;
    };
    HSRangeSlider.prototype.init = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        this.createCollection(window.$hsRangeSliderCollection, this);
        if (typeof ((_a = this.concatOptions) === null || _a === void 0 ? void 0 : _a.formatter) === 'object'
            ? ((_c = (_b = this.concatOptions) === null || _b === void 0 ? void 0 : _b.formatter) === null || _c === void 0 ? void 0 : _c.type) ===
                'thousandsSeparatorAndDecimalPoints'
            : ((_d = this.concatOptions) === null || _d === void 0 ? void 0 : _d.formatter) === 'thousandsSeparatorAndDecimalPoints')
            this.thousandsSeparatorAndDecimalPointsFormatter();
        else if (typeof ((_e = this.concatOptions) === null || _e === void 0 ? void 0 : _e.formatter) === 'object'
            ? ((_g = (_f = this.concatOptions) === null || _f === void 0 ? void 0 : _f.formatter) === null || _g === void 0 ? void 0 : _g.type) === 'integer'
            : ((_h = this.concatOptions) === null || _h === void 0 ? void 0 : _h.formatter) === 'integer')
            this.integerFormatter();
        else if (typeof ((_j = this.concatOptions) === null || _j === void 0 ? void 0 : _j.formatter) === 'object' &&
            (((_l = (_k = this.concatOptions) === null || _k === void 0 ? void 0 : _k.formatter) === null || _l === void 0 ? void 0 : _l.prefix) ||
                ((_o = (_m = this.concatOptions) === null || _m === void 0 ? void 0 : _m.formatter) === null || _o === void 0 ? void 0 : _o.postfix)))
            this.prefixOrPostfixFormatter();
        noUiSlider.create(this.el, this.concatOptions);
        if (this.concatOptions.disabled)
            this.setDisabled();
    };
    HSRangeSlider.prototype.formatValue = function (val) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var result = '';
        if (typeof ((_a = this.concatOptions) === null || _a === void 0 ? void 0 : _a.formatter) === 'object') {
            if ((_c = (_b = this.concatOptions) === null || _b === void 0 ? void 0 : _b.formatter) === null || _c === void 0 ? void 0 : _c.prefix)
                result += (_e = (_d = this.concatOptions) === null || _d === void 0 ? void 0 : _d.formatter) === null || _e === void 0 ? void 0 : _e.prefix;
            result += val;
            if ((_g = (_f = this.concatOptions) === null || _f === void 0 ? void 0 : _f.formatter) === null || _g === void 0 ? void 0 : _g.postfix)
                result += (_j = (_h = this.concatOptions) === null || _h === void 0 ? void 0 : _h.formatter) === null || _j === void 0 ? void 0 : _j.postfix;
        }
        else
            result += val;
        return result;
    };
    HSRangeSlider.prototype.integerFormatter = function () {
        var _this = this;
        var _a;
        this.format = {
            to: function (val) { return _this.formatValue(Math.round(val)); },
            from: function (val) { return Math.round(+val); },
        };
        if ((_a = this.concatOptions) === null || _a === void 0 ? void 0 : _a.tooltips)
            this.concatOptions.tooltips = this.format;
    };
    HSRangeSlider.prototype.prefixOrPostfixFormatter = function () {
        var _this = this;
        var _a;
        this.format = {
            to: function (val) { return _this.formatValue(val); },
            from: function (val) { return +val; },
        };
        if ((_a = this.concatOptions) === null || _a === void 0 ? void 0 : _a.tooltips)
            this.concatOptions.tooltips = this.format;
    };
    HSRangeSlider.prototype.thousandsSeparatorAndDecimalPointsFormatter = function () {
        var _this = this;
        var _a;
        this.format = {
            to: function (val) {
                return _this.formatValue(new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }).format(val));
            },
            from: function (val) { return parseFloat(val.replace(/,/g, '')); },
        };
        if ((_a = this.concatOptions) === null || _a === void 0 ? void 0 : _a.tooltips)
            this.concatOptions.tooltips = this.format;
    };
    HSRangeSlider.prototype.setDisabled = function () {
        this.el.setAttribute('disabled', 'disabled');
        this.el.classList.add('disabled');
    };
    // Static methods
    HSRangeSlider.getInstance = function (target, isInstance) {
        if (isInstance === void 0) { isInstance = false; }
        var elInCollection = window.$hsRangeSliderCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        return elInCollection
            ? isInstance
                ? elInCollection
                : elInCollection.element.el
            : null;
    };
    HSRangeSlider.autoInit = function () {
        if (!window.$hsRangeSliderCollection)
            window.$hsRangeSliderCollection = [];
        document
            .querySelectorAll('[data-hs-range-slider]:not(.--prevent-on-load-init)')
            .forEach(function (el) {
            if (!window.$hsRangeSliderCollection.find(function (elC) { var _a; return ((_a = elC === null || elC === void 0 ? void 0 : elC.element) === null || _a === void 0 ? void 0 : _a.el) === el; }))
                new HSRangeSlider(el);
        });
    };
    // Backward compatibility
    HSRangeSlider.on = function (evt, target, cb) {
        var elInCollection = window.$hsRangeSliderCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string' ? document.querySelector(target) : target);
        });
        if (elInCollection)
            elInCollection.element.events[evt] = cb;
    };
    return HSRangeSlider;
}(base_plugin_1.default));
window.addEventListener('load', function () {
    HSRangeSlider.autoInit();
    // Uncomment for debug
    // console.log('Range slider collection:', window.$hsRangeSliderCollection);
});
if (typeof window !== 'undefined') {
    window.HSRangeSlider = HSRangeSlider;
}
exports.default = HSRangeSlider;
